import './i18n'; // ⬅️ OBBLIGATORIO, PRIMA DI TUTTO
import React from 'react';
import ReactDOM from 'react-dom/client';
import i18n from './i18n/index';
import App from './App'; 
import './index.css';

// Ensure i18n is initialized before rendering
if (!i18n.isInitialized) {
  console.warn('[I18N] i18n not initialized, waiting...');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);